export enum ManagedSolutionsAccountsColumns {
	id = "Id",
	userIds = "User IDs",
	type = "Type",
	createdAt = "Created At",
	status = "Status",
	balance = "Balance",
	routingNumber = "Routing Number",
	accountNumber = "Account Number",
}

export type AllowedManagedSolutionsAccountsColumns =
	| ManagedSolutionsAccountsColumns.id
	| ManagedSolutionsAccountsColumns.userIds
	| ManagedSolutionsAccountsColumns.type
	| ManagedSolutionsAccountsColumns.createdAt
	| ManagedSolutionsAccountsColumns.status
	| ManagedSolutionsAccountsColumns.balance
	| ManagedSolutionsAccountsColumns.routingNumber
	| ManagedSolutionsAccountsColumns.accountNumber
